import styles from "./styles";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useLocaleProvider, useTranslate } from "../../context/locale-provider";

const ContinueShopping = ({ isAlister }) => {
  const { languageStrings, localisedLinks } = useLocaleProvider();
  const translate = useTranslate({ languageStrings });
  return (
    <div className={styles.continueShoppingContainer}>
      <a
        href={localisedLinks.homepage}
        className={classNames(
          styles.continueShoppingLink,
          styles[!isAlister ? "colorBlack" : "colorWhite"]
        )}
      >
        <div
          className={classNames(styles.continueShopping, {
            [styles.continueShoppingAlist]: isAlister,
          })}
        >
          {translate("loyalty_landing_page_join_success_screen_secondary_cta")}
        </div>
      </a>
    </div>
  );
};

ContinueShopping.propTypes = {
  isAlister: PropTypes.boolean,
};

export default ContinueShopping;
